<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>Pick-up a job</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<mat-divider class="mx-20!" />
<div mat-dialog-content>
  <form class="grid! grid-cols-3 gap-x-20" [formGroup]="pickupForm">
    <mat-form-field>
      <mat-label>Insurer</mat-label>
      <mat-select panelClass="auto-width-select" formControlName="insurer" required (selectionChange)="selectInsurer()">
        @for (insurer of insurers; track insurer) {
          <mat-option [value]="insurer.insurerId">
            {{ insurer.insurerName }}
          </mat-option>
        }
      </mat-select>
      @if (insurer.hasError('required')) {
        <mat-error> Insurer is <strong>required</strong> </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>REGO</mat-label>
      <input formControlName="rego" required matInput oninput="value = value.toUpperCase()" />
      @if (rego.hasError('required')) {
        <mat-error> REGO is <strong>required</strong> </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Claim Number</mat-label>
      <input formControlName="claimNumber" matInput />
    </mat-form-field>
    @if (showInspectionDate()) {
      <mat-form-field class="medium-field">
        <mat-label>Inspection Date</mat-label>
        <input
          (keypress)="dateInputHelper.restrictDateInput($event)"
          [matDatepicker]="inspectionDatepicker"
          [min]="minDate"
          [matDatepickerFilter]="availableDatesFilter"
          formControlName="inspectionDate"
          matInput />
        <mat-datepicker-toggle [for]="inspectionDatepicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #inspectionDatepicker></mat-datepicker>
        <mat-hint>Date format DD/MM/YYYY</mat-hint>
        @if (inspectionDate.hasError('matDatepickerParse')) {
          <mat-error> The date format is <strong>DD/MM/YYYY</strong> </mat-error>
        }
        @if (inspectionDate.hasError('matDatepickerFilter') || inspectionDate.hasError('matDatepickerMin')) {
          <mat-error> The date is not available </mat-error>
        }
      </mat-form-field>
    }
  </form>
  @if (showProgressBar()) {
    <mat-progress-bar mode="indeterminate" />
  }
</div>
<mat-divider class="mx-20!" />
<mat-dialog-actions>
  <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
  <button
    matButton="elevated"
    class="red-button"
    type="submit"
    [disabled]="pickupForm.invalid || pending()"
    (click)="pickUpJob()">
    PICK-UP
  </button>
</mat-dialog-actions>
